import { c as _c } from "react/compiler-runtime";
import { CLASSIFICATIONS } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserCICTypeIconWrapper from "@/components/user/utils/user-cic-type/UserCICTypeIconWrapper";
import UserPageClassificationWrapper from "./classification/UserPageClassificationWrapper";
import UserPageHeaderNameWrapper from "./UserPageHeaderNameWrapper";
export default function UserPageHeaderName(t0) {
  const $ = _c(21);
  const {
    profile,
    canEdit,
    mainAddress
  } = t0;
  let t1;
  if ($[0] !== mainAddress || $[1] !== profile.display || $[2] !== profile.handle) {
    const getDisplayName = () => {
      if (profile?.handle) {
        return profile.handle;
      }
      if (profile.display) {
        return profile.display;
      }
      if (mainAddress.endsWith(".eth")) {
        return mainAddress;
      }
      return mainAddress;
    };
    t1 = getDisplayName();
    $[0] = mainAddress;
    $[1] = profile.display;
    $[2] = profile.handle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const displayName = t1;
  let t2;
  if ($[4] !== displayName) {
    t2 = <p className="tw-break-all tw-text-left tw-mb-0 tw-text-2xl sm:tw-text-3xl tw-font-semibold">{displayName}</p>;
    $[4] = displayName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== canEdit || $[7] !== profile || $[8] !== t2) {
    t3 = <UserPageHeaderNameWrapper profile={profile} canEdit={canEdit}>{t2}</UserPageHeaderNameWrapper>;
    $[6] = canEdit;
    $[7] = profile;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== profile) {
    t4 = profile?.handle && <div className="tw-ml-2 tw-flex tw-items-center tw-justify-center tw-self-center tw-h-6 tw-w-6"><UserCICTypeIconWrapper profile={profile} /></div>;
    $[10] = profile;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <div className="tw-flex tw-items-center">{t3}{t4}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== canEdit || $[16] !== profile) {
    t6 = profile?.classification && <UserPageClassificationWrapper profile={profile} canEdit={canEdit}><div className="tw-block tw-text-iron-400 hover:tw-text-iron-300 tw-font-medium tw-text-sm tw-leading-3 tw-transition tw-duration-300 tw-ease-out">{CLASSIFICATIONS[profile.classification].title}</div></UserPageClassificationWrapper>;
    $[15] = canEdit;
    $[16] = profile;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className="tw-mt-2 sm:tw-mt-3">{t5}{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}